import { render } from "./VsudDate.vue?vue&type=template&id=b3ee4f76&scoped=true"
import script from "./VsudDate.vue?vue&type=script&lang=js"
export * from "./VsudDate.vue?vue&type=script&lang=js"

import "./VsudDate.vue?vue&type=style&index=0&id=b3ee4f76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ee4f76"]])

export default __exports__